import { render } from "./CariResit.vue?vue&type=template&id=22dc0766"
import script from "./CariResit.vue?vue&type=script&lang=js"
export * from "./CariResit.vue?vue&type=script&lang=js"

import "./CariResit.vue?vue&type=style&index=0&id=22dc0766&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__